import ProductPage from "components/ProductPage";
import { getListInstitutionalWebsites } from "../data";

function InstitucionalSite02() {
  const data = getListInstitutionalWebsites().filter(
    (item: any) => item.productId === "#STI02"
  );

  return <ProductPage pageData={data} />;
}

export default InstitucionalSite02;